export class ParametersValidation {

    static checkRequired(param) {
        for (let k in param) {
            if (!param[k]) throw new Error(`parameter ${k} is required`)
        }
    }

}